export const DEFAULT_IMAGE_SORT = "date_uploaded__desc";

export const IMAGE_SORT_FIELDS = [
    { label: "File Name", field: "file_name" },
    { label: "Caption", field: "caption" },
    { label: "Uploaded By", field: "uploaded_by" },
    { label: "Date Uploaded", field: "date_uploaded" },
    { label: "Date Modified", field: "date_modified" },
    { label: "Date Taken", field: "date_taken" },
    { label: "Assigned Date", field: "date_assigned" }
];

export const IMAGE_SORT_ALLOWLIST = IMAGE_SORT_FIELDS.flatMap(({ field }) => ["asc", "desc"].map(order => `${field}__${order}`));

export const IMAGE_SORT_ORDERS = [
    { value: "desc", label: "Descending" },
    { value: "asc", label: "Ascending" }
];

export const validateImageSort = imageSort => {
    if (imageSort && IMAGE_SORT_ALLOWLIST.includes(imageSort)) {
        return imageSort;
    }
    return DEFAULT_IMAGE_SORT;
};

export const parseImageSort = imageSort => {
    const validatedSort = validateImageSort(imageSort);
    const separatorIndex = validatedSort.lastIndexOf("__");
    return {
        field: validatedSort.slice(0, separatorIndex),
        order: validatedSort.slice(separatorIndex + 2),
        imageSort: validatedSort
    };
};

export const buildImageSort = (field, order) => validateImageSort(`${field}__${order}`);
